import React from 'react';
import AutomaticPanel from '@/components/PortMatch';
import { getPortsObjAndSubcktList, handleAutoMatchPort } from '../../../../../services/Andes_v2/channel/channelBuilder';
import libraryConstructor from '../../../../../services/Andes_v2/library/libraryConstructor';
import { modelTypeToLibrarys } from '../../../../../services/Andes_v2/channel/channelBuilder/constant';

class AutoPortMatch extends React.Component {
  constructor() {
    super();
    this.state = {
      automaticInfo: {}, // { modelType, modelFileKey: modelType }
      subcktList: [], //[ { libraryId:"", fileName, models:[{ name:"", ports:[ port:"", info:"",...] } ], } ]
      portsObj: {}, //{ libraryId: [{ fileName, type, subckt, ports:[{ port:"",info:"", select: true/false}] } }] }
      libraryListObj: {}, //{ modelTypeList: [], selectOptions: [] }
    }
  }

  componentDidMount() {
    const { autoPortMatchParams = {} } = this.props;
    this.setData();
    this.getFileParse([...(autoPortMatchParams.files || [])]);
  }

  componentDidUpdate(prevProps) {
    const { libraryStatus, autoPortMatchParams = {} } = this.props;
    if (prevProps.libraryStatus !== libraryStatus || (prevProps.autoPortMatchParams || {}).modelType !== autoPortMatchParams.modelType) {
      this.setData();
    }
  }

  setData = () => {
    const { autoPortMatchParams: { modelType, modelFileKey } } = this.props;
    let libraryListArr = [], fileList = [];
    for (const key of Object.keys(modelTypeToLibrarys)) {
      const libraryList = libraryConstructor.getLibraryValueList(modelTypeToLibrarys[key]).filter(item => item.fileType !== 'Folder');
      fileList.push(...libraryList);
      const obj = {
        label: key,
        options: libraryList.map(item => { return { label: item.name, value: item.id } })
      }
      if (key === modelType) {
        libraryListArr.unshift(obj);
      } else {
        libraryListArr.push(obj);
      }
    }

    // const terminationList = libraryConstructor.getLibraryValueList(modelTypeToLibrarys[DIE_TERMINATION]);
    this.setState({
      automaticInfo: {
        modelType,
        modelFileKey
      },
      libraryListObj: {
        [`${(modelType || "").toLowerCase()}List`]: fileList,
        selectOptions: libraryListArr,
      }
    })
  }

  getFileParse = (files, isUpdate, fileType, isGetSubcktList) => {
    if (!files || files.length === 0) {
      return;
    }
    //filter libraryId not exist files
    const _files = files.filter(item => !!item.libraryId);
    const { autoPortMatchParams: { pairs } } = this.props;
    const { portsObj, subcktList } = this.state;
    //get files ports
    return getPortsObjAndSubcktList(
      _files,
      pairs,
      portsObj,
      subcktList,
      isGetSubcktList,
      (_portsObj, _subcktList) => {
        this.setState({
          portsObj: _portsObj,
          subcktList: _subcktList
        })
      }
    )
  }

  automaticMatchPort = (fileInfo, matchType, save, swapTypes) => {
    const { portsObj } = this.state;
    if (fileInfo.libraryId && save) {
      const { components, autoPortMatchParams: { pairs, modelIndex, targetComps, type, /*modelType, topology*/ } } = this.props;
      const newComponents = handleAutoMatchPort(matchType, fileInfo, portsObj, type, pairs, components, targetComps, modelIndex, /*modelType, topology*/ swapTypes);

      if (typeof newComponents !== 'boolean') {
        this.props.updateChannelComponents(newComponents, true);
      }
    }
    this.props.closeAutoPortMatch();
  }

  render() {
    const { subcktList, automaticInfo, libraryListObj } = this.state;
    const { autoPortMatchParams } = this.props;
    return Object.keys(automaticInfo).length > 0 ? <AutomaticPanel
      automaticInfo={automaticInfo}
      closePanel={this.automaticMatchPort}
      libraryListObj={libraryListObj}
      getFileParse={this.getFileParse}
      modelType={automaticInfo.modelType}
      files={autoPortMatchParams.files}
      subcktList={subcktList}
      allowManual={true}
      isSwap={true}
      modelSelectType="andes-channel-builder"
    /> : null;
  }
}

export default AutoPortMatch;